export default "https://assets.pclncdn.com/web/next-landing/6889411/_next/static/images/chicago-1384e0884555523fd79e5c352e67f177.webp";